exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/*!\n * Copyright (c) 2017 DV Bern AG, Switzerland\n *\n * Das vorliegende Dokument, einschliesslich aller seiner Teile, ist urheberrechtlich\n * geschuetzt. Jede Verwertung ist ohne Zustimmung der DV Bern AG unzulaessig. Dies gilt\n * insbesondere fuer Vervielfaeltigungen, die Einspeicherung und Verarbeitung in\n * elektronischer Form. Wird das Dokument einem Kunden im Rahmen der Projektarbeit zur\n * Ansicht uebergeben ist jede weitere Verteilung durch den Kunden an Dritte untersagt.\n *\n */.dv-fremdkosten-list .rowHeader-schaetzung{width:0}.dv-fremdkosten-list .rowHeader-berechtigterBetrag,.dv-fremdkosten-list .rowHeader-betrag,.dv-fremdkosten-list .rowHeader-leistungsart,.dv-fremdkosten-list .rowHeader-rechnungsdatum,.dv-fremdkosten-list .rowHeader-rechnungsnummer{width:15%}.dv-fremdkosten-list .rowHeader-actions{width:130px}.dv-fremdkosten-list .rowBody-actions{text-align:center}.dv-fremdkosten-list .rowBody-actions button{width:30px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/dist/cjs.js!./src/app/core/component/dv-fremdkosten-list/dv-fremdkosten-list.scss
// module id = TnNA
// module chunks = 0